/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import {
    Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';
import JmpModal from './customModal';
import Select, { components } from 'react-select';
import loadsStore from '../../../stores/loads-store';


class RemovableJumper extends Component {

    constructor(props) {

        super(props);
        this.setEditable = this.setEditable.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            editMode: false,
            load: props.load,
            jumpTypes: []
        };
        this.selectFunJumpType = null
    }
    componentDidMount() {
        this.setState({ jumpTypes: loadsStore.getFunJumpTypes() })

        document.addEventListener('click', this.handleClickOutside, true);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                editMode: false
            });
        }
    }
    setEditable = () => {
        this.setState({
            editMode: !this.state.editMode
        })
    }

    // componentWillMount(){
    //     document.getElementById("dd_jumpType")[0].click();
    // }

    handleSubmit(loadNum, jumpId, jumperId) {
        this.setEditable();
        //console.log(loadNum + " jumpId: " + jumpId + " jumperId: " + jumperId);
        loadsStore.removeJumper(loadNum, jumpId, jumperId);
    }

    // updateJumpType = (value, loadNum, jumpId) => {
    //     if (value.target.value !== "Select Jump Type") {
    //         var jumpBody = {
    //             jumpType: value.target.value
    //         }
    //         var that = this;
    //         var type= value.target.value;
    //         Promise.all([loadsStore.updateFunJumpType(loadNum, jumpId, jumpBody)])
    //         .then(function (result) {
    //             var data = result[0];
    //             if(data === true)
    //             {
    //                 that.setState({ editMode: !that.state.editMode});
    //             }
    //             else
    //             {
    //                 that.setState({ editMode: !that.state.editMode});
    //             }
    //         })
    //     }
    // }


    updateJumpType = (value, loadNum, jumpId) => {
        if (value !== "Select..") {
            var jumpBody = {
                jumpType: value
            }
            var that = this;
            var type = value;
            Promise.all([loadsStore.updateFunJumpType(loadNum, jumpId, jumpBody)])
                .then(function (result) {
                    var data = result[0];
                    if (data === true) {
                        that.setState({ editMode: !that.state.editMode });
                    }
                    else {
                        that.setState({ editMode: !that.state.editMode });
                    }
                })
        }
    }
    renderJumpSize = () => {
        if (this.props.jumpType !== "Solo Student") {
            if (this.props.funJump.jumpers.length == 1) {
                return "Solo";
            }
            else {
                var str = "";
                if (this.props.funJump.jumpers.filter(j => j.isVideographer !== true).length == 1) {
                    str = "Solo";
                }
                else {
                    str = this.props.funJump.jumpers.filter(j => j.isVideographer !== true).length + "-way";
                }
                var numVideographers = this.props.funJump.jumpers.filter(j => j.isVideographer).length;
                if (numVideographers === 0) {
                    return <span>{str}</span>;
                }
                if (numVideographers == 1) {
                    str += " +";
                }
                else if (numVideographers > 1) {
                    str += " + " + numVideographers;
                }
                return <span>{str} <i className="fa fa-xs fa-video-camera"> </i></span>;
            }
        }
        return null;
    };

    render() {
        var jumpMenu = this.state.jumpTypes?.map(type => {
            return (
                <a className="dropdown-item" onClick={() => { this.updateJumpType(type, this.props.loadNum, this.props.jumpId) }} >{type}</a>
            )
        })
        // <button className="btn lightBlueButton jumper-name" onClick={this.setEditable} type="submit" disabled={this.props.disabled}>
        {/* {this.props.jumper.firstname} {this.props.jumper.memberId} {this.props.jumper.gearRental ? "G" : null} {this.state.editMode ? <i onClick={(values) => this.handleSubmit(this.props.loadNum, this.props.jumpId, this.props.jumper._id)} className='fa fa-close'></i> : null} */ }
        // </button>
        return (
            <React.Fragment>
                {
                    !this.state.editMode ?
                        <div className="funjumpType-button" onClick={this.setEditable} style={{ cursor: 'pointer', padding: '0 1 0 4px' }}><strong style={{ fontSize: this.props.jumpType.length > 6 && "16px" }}>{this.renderJumpSize()} {this.props.jumpType}</strong></div>
                        :
                        <div class="dropdown-menu" ref={ref => this.selectFunJumpType = ref} onBlur={() => { this.setState({ editMode: false }) }}>
                            <a class="dropdown-item" d >Select..</a>

                            {jumpMenu}
                        </div>
                }
            </React.Fragment>
        );
    }
}

export default RemovableJumper
